import { useTranslation } from 'react-i18next';

// 语言代码到翻译key的映射
const LANGUAGE_TRANSLATION_MAP: Record<string, string> = {
  'zh-Hans': 'chinese',
  en: 'english',
  ja: 'japanese',
  ko: 'korean',
  vi: 'vietnamese',
  pt: 'portuguese',
  'pt-BR': 'portuguese_brazil',
  id: 'indonesian',
  ne: 'nepali',
  es: 'spanish',
  my: 'burmese',
};

// 语言的原生名称
const LANGUAGE_NATIVE_NAMES: Record<string, string> = {
  'zh-Hans': '中文',
  en: 'English',
  ja: '日本語',
  ko: '한국어',
  vi: 'Tiếng Việt',
  pt: 'Português',
  'pt-BR': 'Português (Brasil)',
  id: 'Bahasa Indonesia',
  ne: 'नेपाली',
  es: 'Español',
  my: 'မြန်မာ',
};

const getLanguageOptions = (arr: string[], currentLang: string, t: any) => {
  return arr.map((item) => {
    const nativeName = LANGUAGE_NATIVE_NAMES[item] || item;

    // 如果是当前选中的语言，不显示翻译括号
    if (item === currentLang) {
      return {
        label: nativeName,
        value: item,
      };
    }

    // 显示原生名称 + 当前语言的翻译
    const translationKey = LANGUAGE_TRANSLATION_MAP[item];
    const translatedName = translationKey ? t(`language.${translationKey}`) : '';

    return {
      label: translatedName ? `${nativeName} (${translatedName})` : nativeName,
      value: item,
    };
  });
};

export const useLanguageOptions = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const supportedLanguage = ['ja', 'en', 'zh-Hans', 'ko', 'vi', 'pt', 'pt-BR', 'id', 'ne', 'es', 'my'];

  const languageOptions = getLanguageOptions(supportedLanguage, currentLang, t);

  return languageOptions;
};
